import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';
import assign from 'lodash/assign';
import PropTypes from 'prop-types';
import MuiTypography from 'material-ui/Typography';
import styles from './styles';

@withStyles(styles)
export default class Typography extends Component {
  static propTypes = {
    classes: PropTypes.any.isRequired,
    color: PropTypes.any,
    className: PropTypes.any,
  };

  render() {
    const { color, className, classes, ...rest } = this.props;

    if (color === 'error') {
      assign(rest, {
        className: classNames(className, classes.colorError)
      });
    } else {
      assign(rest, { className, color });
    }

    return (
      <MuiTypography {...rest} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/atoms/Typography/index.js